// Gedeelde staat van de beheeromgeving. Eén object, zodat elke module dezelfde
// waarden leest. Destructureer hier nooit uit (`const { teams } = state`): dan
// heb je een kopie die stil uit de pas loopt zodra een ander hem vervangt.
//
// Het object is verzegeld. Een typefout als `state.team = ...` gooit een
// TypeError in plaats van een nieuwe, stille eigenschap te maken.
export const state = Object.seal({
  // Het geselecteerde toernooi en zijn inschrijvingen.
  events: [],
  // Toernooien van de organisatie; elke editie (event) hoort bij één toernooi.
  tournaments: [],
  // Het toernooi waarin je werkt. Leeg op het overzicht van alle toernooien:
  // dan staat het menu van één toernooi of editie nog niet open.
  currentTournamentId: null,
  currentEventId: null,
  teams: [],
  // Clubregister, geladen bij het openen van de clubpagina.
  allClubs: [],

  // Rol en organisatie van de ingelogde gebruiker. De database dwingt af wat
  // die rol mag; deze waarden zijn voor de weergave en voor inserts in
  // organisation_members, waar geen trigger op zit.
  currentUserEmail: '',
  currentRole: null,
  currentOrgId: null,
  currentOrg: null,
});
